import React from "react";
import { Label, Input } from "src/components";
import styled from "styled-components";

interface Step5PaymentOptionsProps {
  MealActiveBoxGroup: React.ComponentType<any>;
  MealTypeBoxGroup: React.ComponentType<any>;
  RoomActiveBoxGroup: React.ComponentType<any>;
  RoomTypeBoxGroup: React.ComponentType<any>;
  ShopActiveBoxGroup: React.ComponentType<any>;
  PayTypeBoxGroup: React.ComponentType<any>;
  mealActiveIds?: number[];
  mealTypeActiveIds?: number[];
  roomActiveIds?: number[];
  roomTypeActiveIds?: number[];
  shopActiveIds?: number[];
  activePayTypeIds?: number[];
  shopItemValue: string;
  handleShopItemValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  additionalCommentValue: string;
  onAdditionalCommentChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  _onCancel?: () => void;
  _onNext?: () => void;
  onPrevious?: () => void;
  onSubmit?: () => void;
}

export default function Step5PaymentOptions({
  MealActiveBoxGroup,
  MealTypeBoxGroup,
  RoomActiveBoxGroup,
  RoomTypeBoxGroup,
  ShopActiveBoxGroup,
  PayTypeBoxGroup,
  mealActiveIds,
  roomActiveIds,
  shopActiveIds,
  shopItemValue,
  handleShopItemValueChange,
  additionalCommentValue,
  onAdditionalCommentChange,
  _onCancel,
  _onNext,
  onPrevious,
  onSubmit,
}: Step5PaymentOptionsProps) {
  // 컴포넌트가 마운트될 때 화면을 최상단으로 스크롤

  return (
    <ST5Container>
      {/* Main Content */}
      <div className="main-content">
        <div className="d-flex fd-c gap-1">
          <Label content="식사" className="bold" />
          <div className="d-flex">
            <div className="flex-1">
              <MealActiveBoxGroup />
            </div>
            <div className="flex-1" />
          </div>
          {mealActiveIds?.[0] === 1 && <MealTypeBoxGroup />}
        </div>

        <div className="d-flex fd-c gap-1">
          <Label content="룸 이용" />
          <div className="d-flex">
            <div className="flex-1">
              <RoomActiveBoxGroup />
            </div>
            <div className="flex-1" />
          </div>
          {roomActiveIds?.[0] === 1 && <RoomTypeBoxGroup />}
        </div>

        <div className="d-flex fd-c gap-1">
          <Label content="프로샵 이용" className="bold" />
          <div className="d-flex">
            <div className="flex-1">
              <ShopActiveBoxGroup />
            </div>
            <div className="flex-1" />
          </div>
          {shopActiveIds?.[0] === 1 && (
            <div>
              <Input
                label={"시상품"}
                hasValue={!!shopItemValue}
                attr={{ value: shopItemValue, onChange: handleShopItemValueChange }}
              />
            </div>
          )}
        </div>

        <div className="d-flex fd-c gap-1">
          <Label content="결제" className="bold" />
          <PayTypeBoxGroup />
        </div>

        <div className="mb-3">
          <Input
            label="기타사항"
            boldLabel
            hasValue={!!additionalCommentValue}
            attr={{ value: additionalCommentValue, onChange: onAdditionalCommentChange }}
          />
        </div>

        <div className="bottom-comment d-flex fd-c jc-c">
          <p>* 신청하신 조건을 골프장에서 검토한 후에</p>
          <p>
            <span className="fc-red bold">신청승낙 / 조건변경 / 신청거절</span> 을 앱내
            통지드립니다.
          </p>
        </div>
      </div>
      <div className="bottom-nav">
        <div className="button-group">
          <button className="previous-button" onClick={onPrevious}>
            뒤로
          </button>
          <button className="next-button" onClick={onSubmit}>
            제출
          </button>
        </div>
      </div>
    </ST5Container>
  );
}

const ST5Container = styled.div`
  :root {
    --teeshot-white: #fdfdfd;
    --teeshot-black: #1a1a1a;
    --teeshot-gray-2: #d1d5d8;
    --teeshot-gray-3: #f0f0f4;
    --teeshot-gray-1: #79818a;
    --teeshot-active: #007bff;
  }

  min-height: 100vh;
  background: var(--teeshot-white);
  position: relative;
  margin: 0 auto;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;

  /* Main Content */
  .main-content {
    width: 100%;
    padding: 26px 16px;
    padding-bottom: 140px; /* 하단 고정 버튼 공간 확보 */
    min-height: calc(100vh - 140px);
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .bottom-comment {
    width: 100%;
    background-color: #f0f0f4;
    padding: 15px;
  }
  .textSize {
    font-size: 14px;
  }

  /* Bottom Navigation */
  .bottom-nav {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 26px 16px;
    background: linear-gradient(
      0deg,
      #fdfdfd 0%,
      #fdfdfd 60%,
      rgba(253, 253, 253, 0.3) 85%,
      rgba(253, 253, 253, 0) 100%
    );
    backdrop-filter: blur(10px);
    z-index: 1000;
    display: flex;
    gap: 12px;
  }

  .button-group {
    padding-bottom: 24px;
    display: flex;
    gap: 12px;
    width: 100%;
  }

  .previous-button {
    display: flex;
    flex: 1;
    height: 60px;
    padding: 19px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    background: white;
    color: #1a1a1a;
    border: 1px solid #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
    outline: none;
  }

  .previous-button:hover {
    background-color: #f5f5f5;
  }

  .previous-button:active {
    background-color: #e5e5e5;
  }

  .previous-button:focus,
  .previous-button:focus-visible {
    outline: none;
  }

  .next-button {
    display: flex;
    flex: 1;
    height: 60px;
    padding: 19px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    background: var(--Teeshot-Primary-Color-Teeshot-Green, #004b49);
    color: white;
    border: none;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .next-button:hover {
    background-color: #003a38;
  }

  .next-button:active {
    background-color: #002a28;
  }
`;
